<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <v-row>
          <v-col cols="12">
            <DatePicker
              filled
              data-cy="FormDeliveryDate-excludedDeliveryDate"
              :label="$$t('excludedDeliveryDate')"
              v-model="localDeliveryDate.excludedDeliveryDate"
            />
          </v-col>
        </v-row>
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormDeliveryDate-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormDeliveryDate-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import DatePicker from '~src/components/DatePicker.vue';

export default {
  name: 'FormDeliveryDate',
  module: 'Shop',
  mixins: [loading],
  components: {
    DatePicker,
  },
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    DeliveryDate: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localDeliveryDate
      */
      localDeliveryDate: {},
    };
  },
  watch: {
    DeliveryDate() {
      this.localDeliveryDate = this.DeliveryDate;
    },
  },
  created() {
    this.localDeliveryDate = this.DeliveryDate;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localDeliveryDate);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormDeliveryDate example

'''js
<FormDeliveryDate :DeliveryDate="DeliveryDate" />
'''
</docs>
